<template>
    <div class="bg-gradient-loch">
        <a class="skip-main" href="#main">Skip to main content</a>
        <div class="home my-4 px-4 container your-account">
            <div class="row mb-4">
                <div id="main" role="main" class="col-12"  v-if="user">
                    <div class="card shadow mx-auto mt-4 max-width-4 bg-light px-lg-5 px-md-0 px-lg-5">
                        <div class="card-body px-lg-5 text-left">
                            <h2 class="mb-4 mt-3">Your Account</h2>
                            <app-error :error="defaultError" aria-invalid='true'></app-error>
                            <app-success :success="defaultSuccess" aria-invalid='true'></app-success>
                            <div class="mt-3">
                                <div class=" mt-3 row ">
                                    <div class="col-2 mt-1 float-right">
                                        <svg-icon name="account" height="31" width="auto" color="#9C380E"/>
                                    </div>
                                    <div class="col-10 mt-2">
                                        <h3>{{user.first_name}} {{user.last_name}}</h3>
                                    </div>
                                </div>
                                <div class=" mt-3 row ">
                                    <div class="col-2 float-right mt-1">
                                        <svg-icon name="email" height="20" width="auto"/>
                                    </div>
                                    <div class="col-10 mt-2">
                                        <h3>{{user.email}}</h3>
                                    </div>
                                </div>
                                <div class=" mt-3 row " v-if="user.country_code_phone_number">
                                    <div class="col-2 float-right mt-1">
                                        <svg-icon name="phone_red" height="25" width="25"/>
                                    </div>
                                    <div class="col-10 mt-2">
                                        <h3>{{user.country_code_phone_number}}</h3>
                                    </div>
                                </div>
                                <div class=" mt-3 row ">
                                    <div class="col-2 float-right mt-1">
                                        <svg-icon name="time-picker-calendar-icon" height="25" width="auto" ></svg-icon>
                                    </div>
                                    <div class="col-10 mt-2">
                                        <h3>{{formatDate(user.dob)}}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="your-passes">
                                <h2 class="mb-4 mt-3 ">My Passes</h2>
                                <div class="row overflow-auto">
                                   <passes-item :hasCar="user.profile.has_car_access" :hasConsession="user.profile.has_concessionary_pass" :hasYoungScot="user.profile.has_young_scot_card" :railcard="user.profile.railcard" >
                                    </passes-item>
                                </div>
                            </div>
                            <div class="col-12 d-flex">
                                <div class="col-6">
                                    <p><router-link :to="{ name: 'Edit' }" >Edit Account</router-link></p>
                                </div>
                                <div class="col-6 text-right">
                                    <b-button @click="logout()">Logout</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mutationsMapping from '@/store/mutations-mapping'
import {
    mapState,
    mapMutations,
} from 'vuex'
import moment from 'moment'
import AppError from '@/components/AppError.vue'
import AppSuccess from '@/components/AppSuccess.vue'
import PassesItem from './PassesItem.vue'

const whitelabel = require('../../../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {

    name: 'Account',
    components: {
        PassesItem,
        AppError,
        AppSuccess,
    },
    data() {
        return {
            name: whitelabel.brand,
        }
    },
    computed: {
        ...mapState([
            'defaultError',
            'defaultSuccess',
            'user',
            'auth',
        ]),
    },
    methods: {
        ...mapMutations(mutationsMapping),
        logout() {
            this.logoutUser()
            this.$router.push({ name: 'Home' })
        },

        formatDate(value) {
            return moment(String(value)).format('DD-MM-YYYY')
        },
    },

}
</script>
